import { Button } from "./Button";

export function IconButton({ icon, ...props }) {
  return (
    <Button icon={icon} {...props} />
  );
};

